export enum Roles {
  UnitedWayAdministrator = "UA",
  SystemAdministrator = "SA",
  ReportAdministrator= "RA",
  Canvasser = "CA",
  Donor = "DO",
  WorkspaceAdministrator = "WA"
}
